import { render, staticRenderFns } from "./IssueTitle.vue?vue&type=template&id=b26f37b4&scoped=true"
import script from "./IssueTitle.vue?vue&type=script&lang=js"
export * from "./IssueTitle.vue?vue&type=script&lang=js"
import style0 from "./IssueTitle.vue?vue&type=style&index=0&id=b26f37b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26f37b4",
  null
  
)

export default component.exports